(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mega Menu Level 3 Hover and Click Functionality
  document.addEventListener('DOMContentLoaded', function() {
    // Get all mega menu containers
    const megaMenus = document.querySelectorAll('.mega-menu');
    
    megaMenus.forEach(function(megaMenu) {
      const parentItems = megaMenu.querySelectorAll('.mega-menu__parent-item');
      const level3Lists = megaMenu.querySelectorAll('.mega-menu__level3-list');
      
      // Hide all level 3 lists by default
      level3Lists.forEach(function(list) {
        list.style.display = 'none';
        list.style.opacity = '0';
        list.style.visibility = 'hidden';
      });
      
      // Remove active class from all parent items initially
      parentItems.forEach(function(item) {
        item.classList.remove('active');
      });
      
      parentItems.forEach(function(parentItem) {
        const parentLink = parentItem.querySelector('.mega-menu__link--level-2');
        const parentHandle = parentLink.id.split('-').pop();
        
        // Hover functionality for desktop
        parentItem.addEventListener('mouseenter', function() {
          // Remove active class from all parent items in this mega menu
          parentItems.forEach(function(item) {
            item.classList.remove('active');
          });
          
          // Hide all level 3 lists in this mega menu
          level3Lists.forEach(function(list) {
            list.style.display = 'none';
            list.style.opacity = '0';
            list.style.visibility = 'hidden';
          });
          
          // Show the corresponding level 3 list
          const correspondingList = megaMenu.querySelector(`[data-parent="${parentHandle}"]`);
          if (correspondingList) {
            correspondingList.style.display = 'flex';
            // Use requestAnimationFrame for smooth transitions
            requestAnimationFrame(() => {
              correspondingList.style.opacity = '1';
              correspondingList.style.visibility = 'visible';
            });
          }
        });
        
        // Click functionality for mobile/touch devices (fallback)
        parentItem.addEventListener('click', function(e) {
          // Only prevent default if it's a touch device or mobile
          if (window.innerWidth <= 768 || 'ontouchstart' in window) {
            e.preventDefault();
            
            // Remove active class from all parent items in this mega menu
            parentItems.forEach(function(item) {
              item.classList.remove('active');
            });
            
            // Hide all level 3 lists in this mega menu
            level3Lists.forEach(function(list) {
              list.style.display = 'none';
              list.style.opacity = '0';
              list.style.visibility = 'hidden';
            });
            
            // Toggle active class on clicked parent
            if (parentItem.classList.contains('active')) {
              parentItem.classList.remove('active');
            } else {
              parentItem.classList.add('active');
              // Show the corresponding level 3 list
              const correspondingList = megaMenu.querySelector(`[data-parent="${parentHandle}"]`);
              if (correspondingList) {
                correspondingList.style.display = 'flex';
                // Use requestAnimationFrame for smooth transitions
                requestAnimationFrame(() => {
                  correspondingList.style.opacity = '1';
                  correspondingList.style.visibility = 'visible';
                });
              }
            }
          }
        });
      });
      
      // Hide all level 3 lists when mouse leaves the mega menu
      megaMenu.addEventListener('mouseleave', function() {
        level3Lists.forEach(function(list) {
          list.style.display = 'none';
          list.style.opacity = '0';
          list.style.visibility = 'hidden';
        });
        parentItems.forEach(function(item) {
          item.classList.remove('active');
        });
      });
    });
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
